import { QueryExpression } from "./QueryExpression.js";
import { QuerySegment } from "./QuerySegment.js";
/**
 * Class that represents a Query operator
 */
export class QueryOperators extends QuerySegment {
  /**
   * AND Content Query operator
   */
  get and() {
    this.stringValue = ' AND ';
    this.segmentType = 'and';
    return this.finialize();
  }

  /**
   * OR Content Query operator
   */
  get or() {
    this.stringValue = ' OR ';
    this.segmentType = 'or';
    return this.finialize();
  }

  /**
   * Finializes a Query operator
   */
  finialize() {
    this.queryRef.addSegment(this);
    return new QueryExpression(this.queryRef);
  }
}
//# sourceMappingURL=QueryOperators.js.map